<template>
  <div>
    <HeadItem />
    <router-view />
    <FootItem v-if="viewWidth >= 854" />
  </div>
</template>

<script>
import { banner } from "@/api/link";
import FootItem from "@/components/home/FootItem.vue";
import HeadItem from "@/components/home/HeadItem.vue";
export default {
  name: "HelloWorld",
  components: {
    HeadItem,
    FootItem
  },
  data() {
    return {
      viewWidth: window.innerWidth,
    };
  },
  mounted() {
    // 实时获取浏览器当前宽度
    window.onresize = () => {
      const viewWidth = window.innerWidth;
      this.viewWidth = viewWidth;
    };
  },
  methods: {
    fun(val) {
      this.$router.push(val);
    },
    bannerRoute(item) {
      if (item.type == "article") {
        this.$router.push({
          name: "bookInfo",
          query: { type: item.type_id, id: item.data_id }
        });
      }
    },
  }
};
</script>

<style scoped lang="scss"></style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue